/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as Styles from '../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../SharedModules/CustomAgGridEditor/inputComponent';
import { cellRenderer } from '../../../SharedModules/utilities/utilities';

const comparatorQtr = (a, b, nodeA, nodeB, isDescending) => {
  const splittedQtrA = a?.split('Q');
  const splittedQtrB = b?.split('Q');
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};
const comparator = (a, b, nodeA, nodeB, isDescending) => {
  const aValue = parseFloat(a.replace('$', '').replace(/,/g, ''));
  const bValue = parseFloat(b.replace('$', '').replace(/,/g, ''));

  return aValue - bValue;
};
const textMatcherAmount = ({ filterOption, value: val, filterText }) => {
  const value = Math.abs(val).toString();
  const valueWithDollar = `$ ${value}`;
  if (filterText == null) {
    return false;
  }
  switch (filterOption) {
    case 'contains':
      return (
        value.indexOf(filterText) >= 0 ||
        valueWithDollar.indexOf(filterText) >= 0
      );
    case 'notContains':
      return (
        value.indexOf(filterText) < 0 || valueWithDollar.indexOf(filterText) < 0
      );
    case 'equals':
      return value === filterText || valueWithDollar.indexOf(filterText) === 0;
    case 'notEqual':
      return value != filterText.replace('$', '');
    case 'startsWith':
      return (
        value.indexOf(filterText) === 0 ||
        valueWithDollar.indexOf(filterText) === 0
      );
    case 'endsWith':
      const index =
        value.lastIndexOf(filterText) || valueWithDollar.indexOf(filterText);
      return index >= 0 && index === value.length - filterText.length;
    default:
      return false;
  }
};

export const tableHead = [
  {
    headerName: 'Actions',
    // field: 'mailed',
    editable: false,
    sortable: false,
     hideFilterIcon: true,
    filter: false,
    suppressMenu: false,
    resizable: false,
    minWidth: Styles.Width_100,
    cellRenderer: 'ActionCellRender',
    pdfExportOptions: {
      skipColumn: true,
    },
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
  },
  {
    headerName: 'Quarter',
    field: 'qtr',
    comparator: comparatorQtr,
    editable: false,
    sortable: true,
    sort: 'desc',
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_125,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Invoice Number',
    field: 'invoice_NUM',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    // sort: 'asc',
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    excelAlignment: 'right',
    alignment: 'right',
    //isTextColorRed: true,
  },
  {
    headerName: 'Principal Due',

    field: 'principal_BAL',
    // valueFormatter: dollarFormatter,
    comparator,
    editable: false,
    isTextColorRed: true,
    printPrefixValue: '$',
    sortable: true,
    suppressMenu: false,
    resizable: true,
    printPrefixValue: '$',
    cellRenderer: cellRenderer,
    isAmount: true,
    minWidth: Styles.Width_171,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherAmount,
    },
    isTextColorRed: true,
    alignment: 'right',
  },
  {
    headerName: 'Interest Due',

    field: 'interest_DUE',
    // valueFormatter: dollarFormatter,
    isAmount: true,
    editable: false,
    isTextColorRed: true,
    printPrefixValue: '$',
    sortable: true,
    suppressMenu: false,
    resizable: true,
    printPrefixValue: '$',
    cellRenderer: cellRenderer,
    comparator,
    minWidth: Styles.Width_171,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherAmount,
    },
    isTextColorRed: true,
    alignment: 'right',
  },
  {
    headerName: 'Balance Due',

    field: 'top_balances_balance_due',
    comparator,
    isAmount: true,
    editable: false,
    isTextColorRed: true,
    printPrefixValue: '$',
    sortable: true,
    suppressMenu: false,
    resizable: true,
    printPrefixValue: '$',
    cellRenderer: cellRenderer,
    minWidth: Styles.Width_171,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherAmount,
    },
    isTextColorRed: true,
    alignment: 'right',
  },
];
